import { homeRoute } from "./home";
import { aboutRoute } from "./about";
import { galleryRoute } from "./gallery"
import { articleRoute } from "./articles";
import { resolutionsRoute } from "./resolutions";
import { usefullLinksRoute } from "./usefullLinks";
import { memberDetailRoute } from "./memberDetail";
import { appRoutes } from "../../../constants/appRoutes";
import { membersRoute } from "./members";

export const dashboardRoutes = {
  path: appRoutes.root.path,
  lazy: () => import("../../../pages/Topbar"),
  children: [
    aboutRoute,
    galleryRoute,
    articleRoute,
    usefullLinksRoute,
    memberDetailRoute,
    homeRoute,
    resolutionsRoute,
    membersRoute
  ]
}